/** @module csi/table/NewChartController */
define([
	"dojo/_base/declare",
	"csi/action/ActionView",
	"csi/def",
	"csi/prefs/_base",
	"csi/wizard/ActionControllerMixin",
	"./ChartController",

	"./ChartForm",
	"./ChartTypeGallery"
], function(declare, ActionView, def, csiPrefs, ActionControllerMixin, ChartController) {

	return declare([ChartController, ActionControllerMixin], {
		idWizardResource: "ChartWizard",

		/** @property {string} _chartTempNodeURL - store temp node url to remove from the cache after the process */
		_chartTempNodeURL: null,

		/**
		 * Return reference to chart wizard defined on _CS_PreferenceView.
		 * @param {ViewRef} vr - ignored
		 * @return {ActionView}
		 */
		getActionView: function(vr) {
			var defType = def.typeDefinition(csiPrefs.TYPE_VIEW);
			var defView = defType.getViewDef("ChartWizard");
			var chartTempNode = this.getCache().createClientNode("", defType.getType());
			this._chartTempNodeURL = chartTempNode.$URL;
			return new ActionView(this, defView, chartTempNode);
		},

		/**
		 * Only allow one selection of chart type, but it is not required.
		 */
		getFormData: function() {
			var fd = this.inherited(arguments);
			fd.m_bSelectOne = true;
			fd.m_bRequireOne = true;
			return fd;
		},

		/**
		 * Pass selected chart type to form.
		 * @param {csi/wizard/Widget} wizard
		 * @param {Content} currentPage
		 * @param {Content} nextPage
		 * @param {boolean} bFinish - indicates if this is being called while finishing wizard
		 * @return {Deferred}
		 */
		onNextPage: function(wizard, currentPage, nextPage, bFinish) {
			var fd = this.getFormData();
			var index = wizard.getIndexOfPage(nextPage);

			if (index == 1) {
				var node = fd.getSelectedNode();
				if (node) {
					var chartTemplate = currentPage.viewTab.getChartTemplate(node);

					if (nextPage.viewTab) {
						nextPage.viewTab.setFieldValue("ChartTemplate", chartTemplate);
					} else {
						fd.setFieldInitialValue("ChartTemplate", chartTemplate);
					}
				}
			}

			return this.inherited(arguments);
		},

		/**
		 * Set chart on first page based on selected value from form.
		 * @param {csi/wizard/Widget} wizard
		 * @param {Content} currentPage
		 * @param {Content} prevPage
		 * @return {Deferred}
		 */
		onPrevPage: function(wizard, currentPage, prevPage) {
			var fd = this.getFormData();
			var chartGallery = prevPage.getView();
			var chartTemplate = currentPage.getView().getFieldValue("ChartTemplate");
			var chartTemplateNode = chartGallery.getChartTemplateNode(chartTemplate);
			var ctx = chartGallery.getContext();

			if (chartTemplateNode) {
				ctx.setNode(chartTemplateNode);
				fd.changeSelection(ctx, true);
			} else {
				fd.resetSelections(ctx);
			}

			return this.inherited(arguments);
		},

		/**
		 * Give form access to chart plugin.
		 * @param {csi/wizard/Widget} wizard
		 * @param {Content} page
		 * @param {View} defView
		 * @param {Object} viewParams
		 */
		onWizardViewPreCreate: function(wizard, page, defView, viewParams) {
			if (wizard.getIndexOfPage(page) == 1) {
				viewParams.chartPlugin = this.actionWidget;
			}
		},

		postProcess: function(bStatus, bRepeat) {
			//remove temp node from the cache
			this.getCache().removeNode(this._chartTempNodeURL);
			this.inherited(arguments);
		}
	});
});
